module.exports = __webpack_public_path__ + "static/media/card-sample.29e17f92.png";